// JACE gedeelde constanten & helpers
export const JACE = "var(--jace)";

export const TYPE_LABELS = { BXG: "BOXING GROUP", BPT: "BOXING PT", BG: "BAG TRAINING", SC: "STRENGTH & CONDITIONING", YTH: "YOUTH" };
export const TYPE_DESC = {
  BXG: "Group-based boxing coaching.",
  BPT: "Individual boxing coaching and development.",
  BG: "Technical and conditioning-based heavy bag training.",
  SC: "Strength, power, movement and conditioning.",
  YTH: "Boxing, movement and athletic development for youth.",
};

export const STATUS_COLORS = {
  DRAFT: "#A3A3A3", PLANNED: "#A3A3A3", READY: "#C6FF3C", "IN PROGRESS": "#C6FF3C",
  "PARTIALLY COMPLETED": "#D4A93A", COMPLETED: "#4ADE80", REVIEWED: "#4ADE80",
  ARCHIVED: "#4A4A4A", CANCELLED: "#F87171", RESCHEDULED: "#D4A93A", "NO SHOW": "#F87171",
};

export const timeStatusColor = (s) => s === "ON TARGET" ? "#4ADE80" : s === "OVER TIME" ? "#F87171" : "#D4A93A";

export const fmtDateNL = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso + "T00:00:00").toLocaleDateString("nl-NL", { weekday: "short", day: "numeric", month: "short" }).toUpperCase();
  } catch { return iso; }
};

export const uid = () => Math.random().toString(36).slice(2, 10);

// ---- Week helpers (ISO, maandag = start) ----
export const mondayOf = (d) => {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate());
  x.setDate(x.getDate() - ((x.getDay() + 6) % 7));
  return x;
};
export const addDays = (d, n) => { const x = new Date(d); x.setDate(x.getDate() + n); return x; };
export const isoDay = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;

export const isoWeek = (d) => {
  const x = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
  const day = (x.getUTCDay() + 6) % 7;
  x.setUTCDate(x.getUTCDate() - day + 3);
  const firstThursday = new Date(Date.UTC(x.getUTCFullYear(), 0, 4));
  const fd = (firstThursday.getUTCDay() + 6) % 7;
  firstThursday.setUTCDate(firstThursday.getUTCDate() - fd + 3);
  return 1 + Math.round((x - firstThursday) / (7 * 86400000));
};

export const WEEKDAY_NL = ["MAANDAG", "DINSDAG", "WOENSDAG", "DONDERDAG", "VRIJDAG", "ZATERDAG", "ZONDAG"];
export const WEEKDAY_SHORT = ["MON", "TUE", "WED", "THU", "FRI", "SAT", "SUN"];
export const MONTH_NL = ["JANUARI", "FEBRUARI", "MAART", "APRIL", "MEI", "JUNI", "JULI", "AUGUSTUS", "SEPTEMBER", "OKTOBER", "NOVEMBER", "DECEMBER"];

export const fmtWeekRange = (monday) => {
  const sun = addDays(monday, 6);
  const fmt = (d) => `${String(d.getDate()).padStart(2, "0")} ${MONTH_NL[d.getMonth()].slice(0, 3)}`;
  return `${fmt(monday)} — ${fmt(sun)}${monday.getFullYear() !== new Date().getFullYear() ? ` ${monday.getFullYear()}` : ""}`;
};

// Weekstatus: EMPTY / IN PROGRESS / READY / COMPLETED
export const weekStatus = (sessions) => {
  const act = (sessions || []).filter((s) => s.status !== "ARCHIVED" && s.status !== "CANCELLED");
  if (act.length === 0) return "EMPTY";
  const done = (s) => ["COMPLETED", "REVIEWED"].includes(s.status);
  if (act.every(done)) return "COMPLETED";
  if (act.every((s) => done(s) || s.status === "READY")) return "READY";
  return "IN PROGRESS";
};

export const WEEK_STATUS_COLORS = { EMPTY: "#4A4A4A", "IN PROGRESS": "#D4A93A", READY: "#4ADE80", COMPLETED: "#4ADE80" };
export const isReady = (s) => ["READY", "COMPLETED", "REVIEWED"].includes(s.status);
export const isDone = (s) => ["COMPLETED", "REVIEWED"].includes(s.status);
